module.exports = __webpack_public_path__ + "static/media/exercise-outdoors.e9337f23.jpeg";